import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'
import { backendForFirebaseUser } from './backendForFirebaseUser'
import { createIdempotencyKey } from './createIdempotencyKey'
import { BackendApiError } from './minecardsBackendClient'

export const setCurrentPin = async (
    cardId,
    shouldPin,
    idempotencyKey = createIdempotencyKey('pin'),
    now = Date.now
) => {
    const normalizedCardId = Number(cardId)
    if (!Number.isSafeInteger(normalizedCardId) || normalizedCardId <= 0) {
        throw new TypeError('Card ID must be a positive integer')
    }

    const user = getAuth(app).currentUser
    const backend = backendForFirebaseUser(user)
    if (backend) {
        return shouldPin
            ? backend.addPin(normalizedCardId, idempotencyKey)
            : backend.removePin(normalizedCardId, idempotencyKey)
    }

    if (!user?.uid) {
        throw new Error('Firebase authentication is required')
    }

    const { db, doc, runTransaction } = await loadLegacyFirestore()
    const profileRef = doc(db, 'Auth', user.uid)
    return runTransaction(db, async (transaction) => {
        const snapshot = await transaction.get(profileRef)
        if (!snapshot.exists()) {
            throw new BackendApiError('Firebase profile was not found', {
                status: 404,
                code: 'profile_not_found',
            })
        }

        const profile = snapshot.data()
        const wantedMoments = momentArray(profile.wantedMoments)
        const pinnedMoments = momentArray(profile.pinnedMoments)
        const alreadyPinned = pinnedMoments.some(
            (entry) => entry.id === normalizedCardId
        )
        if (
            shouldPin &&
            !wantedMoments.some((entry) => entry.id === normalizedCardId)
        ) {
            throw new BackendApiError('Only wanted moments can be pinned', {
                status: 409,
                code: 'pin_requires_wanted',
            })
        }
        if (alreadyPinned === shouldPin) {
            return { changed: false }
        }

        const occurredAt = now()
        const nextPinnedMoments = pinnedMoments.filter(
            (entry) => entry.id !== normalizedCardId
        )
        if (shouldPin) {
            nextPinnedMoments.push({ id: normalizedCardId, time: occurredAt })
        }
        transaction.update(profileRef, {
            pinnedMoments: nextPinnedMoments,
        })
        return { changed: true, occurredAt }
    })
}

const momentArray = (value) => (Array.isArray(value) ? value : [])
